import { supabase } from "@/lib/supabase/supabaseClient";
import { useArchiveProjectProps } from "./useArchiveProject.types";

export const archiveProject = async (project_id: useArchiveProjectProps) => {
    return await supabase.from('project').update({ archived: true }).eq('id', project_id).select();
}
